import { PD_RANGE_BY_FRAME_SIZE } from 'constants/pdRange';
import { UPDATE_PRESCRIPTION_PD_BY_ID } from 'gqlStrings/mutations/Prescription';
import { GET_PDS } from 'gqlStrings/queries/getPrescriptions';
import { client as wcApiApolloClient } from '../apolloclient';

const prescriptionService = {
  async findAllPds(frameSize?: string) {
    const { data } = await wcApiApolloClient.query({
      query: GET_PDS,
      context: { clientName: 'laravel' }
    });
    if (!frameSize) return data.me.pds.data;

    return data.me.pds.data.filter((userPd: any) => {
      if (!frameSize) return true;

      return this.checkIsPdInFrameSizeRange(frameSize, userPd);
    });
  },
  checkIsPdInFrameSizeRange(frameSize: string, pd: any) {
    if(!frameSize) return true;

    const pdRange = PD_RANGE_BY_FRAME_SIZE[frameSize];
    const isMonocular =
      pd?.right_monocular_dist_pd || pd?.left_monocular_dist_pd;

    if (!isMonocular)
      return (
        Number(pd.binocular_dist_pd) >= Number(pdRange.min) &&
        Number(pd.binocular_dist_pd) <= Number(pdRange.max)
      );

    return (
      Number(pd.left_monocular_dist_pd) >= pdRange.min / 2 &&
      Number(pd.left_monocular_dist_pd) <= pdRange.max / 2 &&
      Number(pd.right_monocular_dist_pd) >= pdRange.min / 2 &&
      Number(pd.right_monocular_dist_pd) <= pdRange.max / 2
    );
  },
  async updatePdById(payload: { prescriptionId: string; pdId: string }) {
    const { data } = await wcApiApolloClient.mutate({
      mutation: UPDATE_PRESCRIPTION_PD_BY_ID,
      variables: {
        input: {
          id: payload.prescriptionId,
          pdId: payload.pdId
        }
      },
      context: { clientName: 'laravel' }
    });
    return data;
  }
};

export default prescriptionService;
